import { z } from 'zod';

export const NotificationListItemSchema = z.object({
    active: z.boolean(),
    name: z.string(),
    shownAt: z.string().optional(),
    closedAt: z.string().optional(),
});

export const InputSchema = z.object({
    prompts: z.object({
        notificationList: z.array(NotificationListItemSchema),
    }),
});

export type ApproveNotificationType = z.infer<typeof InputSchema>;
